// extracted by mini-css-extract-plugin
export default {"heading":"Nx-z","corrected":"Ox-z","redirectVerbiageContainer":"Px-z","redirectVerbiageText":"Qx-z"};